export default __webpack_public_path__ + "static/media/TimeIcon.80420a8b.svg";